import React, {useEffect, useRef, useState} from "react";
import { project } from "../../../system/types/project/project";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/reducers";
import { ProjectApi } from "../../../system/api/ProjectApi";
import { dispatch } from "../../../App";
import {actions, store} from "../../../redux";
import { EditProject } from "../Edit/EditProject";
import { initialProject } from "../../../system/initial/project";
import Icon from "@mdi/react";
import {
    mdiDotsVertical,
} from "@mdi/js";
import { ProjectGroups } from "./ProjectGroups";
import { useTranslations } from "../../../hooks/useTranslations";

import "./ProjectBase.scss";
import {ProjectSubMenu} from "./ProjectSubMenu";

const ProjectBase = () => {

    const { t } = useTranslations();

    const [sessionToken, setSessionToken] = useState<string>('');
    const [sessionEmail, setSessionEmail] = useState<string>('');

    const [projectId, setProjectId] = useState<string>('');
    const [projectData, setProjectData] = useState<project>(initialProject);
    const [command, setCommand] = useState<string>('');

    const [showSubMenu, setShowSubMenu] = useState<boolean>(false);

    useSelector((state: RootState) => {

        if (state.activeUser.activeUserToken !== sessionToken) {
            setSessionToken(state.activeUser.activeUserToken);
        }

        if (state.activeUser.activeUserEmail !== sessionEmail) {
            setSessionEmail(state.activeUser.activeUserEmail);
        }

        if (state.project.projectId !== projectId) {
            setProjectId(state.project.projectId);
        }

        if (state.project.projectData !== projectData) {
            setProjectData(state.project.projectData);
        }

        if (state.project.pageCommand !== command) {
            setCommand(state.project.pageCommand);
        }

    });

    const toggleSubMenu = () => {
        setShowSubMenu(!showSubMenu);
    }

    const loadProjectData = async () => {
        const api = new ProjectApi(sessionToken, sessionEmail);
        const data = await api.getProjectData(projectId);
        dispatch(actions.project.setData(data));
    };

    useEffect(() => {
        loadProjectData();
    },[projectId]);

    useEffect(() => {
        if (projectData._id === '' && command !== 'editBaseData') {
            dispatch(actions.project.setPageCommand('editBaseData'));
        }
    }, [projectData]);

    return (<>
        <div className="row mb-3 mt-3 align-items-center">
            <div className="col-auto"><strong>{t('projects.project')}:</strong></div>
            <div className="col">{projectData.name} - {projectData.baseLanguage.name}</div>
            <div className="col-auto sub-menu-wrapper">
                <button onClick={toggleSubMenu} className="btn  btn-outline-primary"><Icon path={mdiDotsVertical} size={1} /></button>
                {showSubMenu ? (<ProjectSubMenu></ProjectSubMenu>) : null}
            </div>
        </div>
        <div className="row mb-3 align-items-start">
            <div className="col">{projectData.description}</div>
        </div>
        <ProjectGroups parentId=""></ProjectGroups>
        {command !== '' ?
            <EditProject></EditProject>
            : null}
    </>);
};

export {ProjectBase};
